import { render } from "./Plantmoxing.vue?vue&type=template&id=75d5f162&scoped=true"
import script from "./Plantmoxing.vue?vue&type=script&lang=js"
export * from "./Plantmoxing.vue?vue&type=script&lang=js"

import "./Plantmoxing.vue?vue&type=style&index=0&id=75d5f162&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-75d5f162"

export default script